// @owners { team: patients }
import { type Brand, getBrand } from '@alto/design-system';
import { FUZERX_PHONE } from '~shared/constants';

/**
 * Get the company support phone number based on the current brand.
 *
 * The brand-keyed map is built inside the call (not at module scope) because constants.ts and this
 * module import each other — a module-level map would capture FUZERX_PHONE before it initializes.
 * Brand-keyed so a future brand slots in as one new entry.
 * @returns string
 */
export const getCompanyPhone = () => {
  const companyPhone: Record<Brand, string> = {
    fuzerx: FUZERX_PHONE,
  };
  return companyPhone[getBrand()];
};
